import tippy from 'tippy.js';

tippy('.tooltip', {
  arrow: false,
  allowHTML: true,
  offset: [0, 3],
  content(reference) {
    const id = reference.getAttribute('data-template');

    if(!id){
      return
    }

    const template = document.getElementById(id);

    return template.innerHTML;
  },
});
